// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthLayout_wrapper__1v7le","container":"AuthLayout_container__2Fzzv","content":"AuthLayout_content__3wD8n","footer":"AuthLayout_footer__jDHmq"};